import {commitMutation, Environment} from "react-relay";
import {relayAuthEnvironment} from "@/RelayEnvironment";
import {graphql} from "relay-runtime";
import {UpdateParameterMutationResponse} from "@/Domains/ConfigurationManagement/Parameter/Parameter/Mutations/__generated__/UpdateParameterMutation.graphql";
import {BaseError} from "@/Utils/BaseError";

export default (
    input: {
        parameter: string;
        value: string;
    },
    onCompleted: (error: Error | null, result?: boolean | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation UpdateParameterMutation(
                $parameter: String!
                $value: String
            ) {
                setParameter(parameter: $parameter, value: $value) {
                    parameterId
                }
            }
        `,
        variables: {
            ...input,
        },
        onCompleted(result) {
            const res = result as UpdateParameterMutationResponse;
            const success: boolean | null | undefined =
                (res?.setParameter?.parameterId?.length || 0) > 0;

            if (success) {
                onCompleted(null, true);
                return;
            }

            throw new BaseError(
                "UpdateParameterMutation failed with an unexpected Error",
                {
                    context: {
                        parameter: input.parameter,
                        value: input.value,
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
